import { useSelector } from 'react-redux';
import { hasFullAdminAccess } from '../utils/roleUtils';

/**
 * Get the current user's role name from Redux.
 */
export function useUserRole(): string | undefined {
  return useSelector((state: any) => state?.rootReducers?.userData?.userDetails?.role?.name);
}

/**
 * Check if the current user has admin-level access.
 * Returns true if:
 *   - role.name is 'super_admin' or 'admin', OR
 *   - isSudoAdmin === true (from auth API)
 *
 * Roles are configured in src/utils/roleUtils.ts → ADMIN_ROLES.
 */
export function useHasAdminAccess(): boolean {
  const userDetails = useSelector((state: any) => state?.rootReducers?.userData?.userDetails);
  return hasFullAdminAccess(userDetails);
}
